/* eslint-disable @typescript-eslint/naming-convention */
import { AtomicOption } from '@df/ui/atomic/atomic.interface';
import { getFontSize } from '@df/ui/atomic/utils/get-font-size';
import { getMargin } from '@df/ui/atomic/utils/get-margin';
import { getPadding } from '@df/ui/atomic/utils/get-padding';
import omit from 'lodash-es/omit';

import * as atomicImport from './../../../../../styles/config/atomic.config';
export const atomicConfig = atomicImport.config;
const atomic: any = omit(atomicImport, 'config') as any;

export const atomicColor = (atomic.color || []) as AtomicOption[];
export const atomicBackgroundColor = (atomic.backgroundColor || []) as AtomicOption[];
export const atomicRatio = (atomic.ratio || []) as AtomicOption[];
export const atomicFontFamily = (atomic.fontFamily || []) as AtomicOption[];
export const atomicFontWeight = (atomic.fontWeight || []) as AtomicOption[];
export const atomicFontStyle = (atomic['fontStyle'] || []) as AtomicOption[];
export const atomicFormSize = (atomic['formSize'] || []) as AtomicOption[];
export const atomicButton = (atomic.button || []) as AtomicOption[];
export const atomicInput = (atomic.input || []) as AtomicOption[];
export const atomicLink = (atomic['link'] || []) as AtomicOption[];
export const atomicTextStyle = (atomic.textStyle || []) as AtomicOption[];
export const atomicGridSize = (atomic.gridSize || []) as AtomicOption[];
export const atomicItemsInRow = (atomic.itemsInRow || []) as AtomicOption[];
export const atomicComponentSize = (atomic['componentSize'] || []) as AtomicOption[];

/**
 * Undefined option
 */
export const UndefinedOption: AtomicOption[] = [
    {
        key: undefined,
        title: '-- select --'
    }
];

/**
 * Colors list
 */
export const ColorOptions: AtomicOption[] = [...UndefinedOption, ...atomicColor];
export const BgColorOptions: AtomicOption[] = [...UndefinedOption, ...atomicBackgroundColor];

/**
 * Ratio options list
 */
export const RatioOptions: AtomicOption[] = [...UndefinedOption, ...atomicRatio];

/**
 * Margin
 */
export const MarginTopOptions: AtomicOption[] = [...UndefinedOption, ...getMargin('t', atomicConfig)];
export const MarginRightOptions: AtomicOption[] = [...UndefinedOption, ...getMargin('r', atomicConfig)];
export const MarginBottomOptions: AtomicOption[] = [...UndefinedOption, ...getMargin('b', atomicConfig)];
export const MarginLeftOptions: AtomicOption[] = [...UndefinedOption, ...getMargin('l', atomicConfig)];

/**
 * Padding
 */
export const PaddingTopOptions: AtomicOption[] = [...UndefinedOption, ...getPadding('t', atomicConfig)];
export const PaddingRightOptions: AtomicOption[] = [...UndefinedOption, ...getPadding('r', atomicConfig)];
export const PaddingBottomOptions: AtomicOption[] = [...UndefinedOption, ...getPadding('b', atomicConfig)];
export const PaddingLeftOptions: AtomicOption[] = [...UndefinedOption, ...getPadding('l', atomicConfig)];

/**
 * Form size
 */
export const FormSizeOptions: AtomicOption[] = [...UndefinedOption, ...atomicFormSize];

/**
 * Buttons list
 */
export const ButtonsOptions: AtomicOption[] = [...UndefinedOption, ...atomicButton];
export const LinksOptions: AtomicOption[] = [...UndefinedOption, ...atomicLink];

/**
 * Text style list
 */
export const TextStyleOptions: AtomicOption[] = [...UndefinedOption, ...atomicTextStyle];

/**
 * Font Size
 */
export const FontSizeOptions: AtomicOption[] = [...UndefinedOption, ...getFontSize(atomicConfig)];

/**
 * Horizontal alignment options
 */
export const HorizontalAlignmentOptions: AtomicOption[] = [
    { key: 'left', title: 'Left' },
    { key: 'center', title: 'Center' },
    { key: 'right', title: 'Right' }
];

/**
 * Horizontal alignment options
 */
export const VerticalAlignmentOptions: AtomicOption[] = [
    { key: 'top', title: 'Top' },
    { key: 'middle', title: 'Middle' },
    { key: 'bottom', title: 'Bottom' }
];
/**
 * @deprecated Use `VerticalAlignmentOptions` instead
 */
export const VerticalAlignnementOptions = VerticalAlignmentOptions;

/**
 * HTML tags
 */
export const HtmlTagOptions: AtomicOption[] = [
    { key: 'h1', title: 'H1' },
    { key: 'h2', title: 'H2' },
    { key: 'h3', title: 'H3' },
    { key: 'h4', title: 'H4' },
    { key: 'h5', title: 'H5' },
    { key: 'h6', title: 'H6' },
    { key: 'p', title: 'P' },
    { key: 'div', title: 'DIV' }
];

/**
 * Layouth width
 */
export const LayoutWidthOptions: AtomicOption[] = [
    ...UndefinedOption,
    { key: 'w-12', title: 'Full width' },
    { key: 'wrap', title: `Fixed width${atomicConfig.layout.width ? ' (' + atomicConfig.layout.width + ')' : ''}` }
];

/**
 * Grid size
 */
export const GridSizeOptions: AtomicOption[] = [...atomicGridSize];

/**
 * Items in row
 */
export const ItemsInRowOptions: AtomicOption[] = [...atomicItemsInRow];

/**
 * Component size list
 */
export const ComponentSizeOptions: AtomicOption[] = [...UndefinedOption, ...atomicComponentSize];

export function getCol(size: number | string): string | undefined {
    return ColorOptions.find(i => i?.key === `col-${size}`)?.value?.toString();
}
